import { theme } from '@theme';
import { FC } from 'react';
import styled from 'styled-components';
import { Icon } from '../../../style/Icon';
import { Typography } from '../../../style/Typography';
import { CloseIconPanel } from '../../../style/essential-ui/CloseIconPanel';

type ModalTitleProps = {
  size?: number;
  color?: string;
  fontWeight?: number;
  iconColor?: string;
  title?: string;
  bgColor?: string;
  handleIconClick?: () => void;
  showCloseIcon?: boolean;
};

const ModalTitle: FC<ModalTitleProps> = (props) => {
  return (
    <Wrapper data-testid='modal-title'>
      <Typography
        size={props.size ?? theme.typography.h4}
        color={props.color ?? theme.palette.white}
        fontWeight={props.fontWeight ?? theme.typography.fontWeights.semibold}
        className='title'
      >
        {props.title}
      </Typography>
      {props.showCloseIcon && (
        <CloseIconPanel onClick={props.handleIconClick}>
          <Icon
            data-testid='close-icon'
            type='x'
            size={26}
            color={props.iconColor ?? theme.palette.white}
          />
        </CloseIconPanel>
      )}
    </Wrapper>
  );
};

export default ModalTitle;

const Wrapper = styled.div<ModalTitleProps>`
  background-color: ${(props) => props.bgColor ?? theme.palette.text.purple};
  display: flex;
  justify-content: space-between;

  .title {
    border-right: ${(props) =>
      props.showCloseIcon ? `2px solid ${theme.palette.translucentPurple}` : 'none'};
    padding: 15px 20px;
    width: 90%;
  }
`;
